import { useSelector } from 'react-redux';
import { getIsMenuOpen } from './index';

export const useIsMenuOpen = () => useSelector(getIsMenuOpen);
